import { useState, FormEvent } from 'react';
import { Button, Input } from '../ui';
import { useAuth } from '../../stores/auth.store';

interface LoginFormProps {
  onSuccess?: () => void;
  onSwitchToRegister?: () => void;
  onForgotPassword?: () => void;
}

export function LoginForm({
  onSuccess,
  onSwitchToRegister,
  onForgotPassword,
}: LoginFormProps) {
  const { signIn, isLoading, error, clearError } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    clearError();

    const success = await signIn(email, password);
    if (success) {
      onSuccess?.();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        required
        fullWidth
        disabled={isLoading}
      />

      <Input
        label="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="••••••••"
        required
        fullWidth
        disabled={isLoading}
      />

      {error && (
        <div className="p-3 rounded-lg bg-red-500/10 border border-red-500/20">
          <p className="text-sm text-red-400">{error}</p>
        </div>
      )}

      <Button type="submit" fullWidth isLoading={isLoading}>
        Sign In
      </Button>

      <div className="flex items-center justify-between text-sm">
        <button
          type="button"
          onClick={onForgotPassword}
          className="text-purple-400 hover:text-purple-300 transition-colors"
        >
          Forgot password?
        </button>
        <button
          type="button"
          onClick={onSwitchToRegister}
          className="text-slate-400 hover:text-white transition-colors"
        >
          Create account
        </button>
      </div>

      {/* Test credentials hint for development */}
      {import.meta.env.DEV && (
        <div className="mt-4 p-3 rounded-lg bg-slate-700/50 text-xs text-slate-400">
          <p className="font-medium text-slate-300 mb-1">Test Account:</p>
          <p>Email: test@example.com</p>
          <p>Password: password123</p>
        </div>
      )}
    </form>
  );
}
